import { Injectable } from '@angular/core';
import { SettingsProvider } from '@services/settings/settings';

@Injectable()
export class TimeConverterProvider {
	constructor(private settingsService: SettingsProvider) {
		this.getTimeFormat();
	}

	private timeFormat: string;

	getTimeFormat(): any {
		this.settingsService.timeFormatSettings.subscribe(data => {
			this.timeFormat = data.timeFormat;
		});
	}

	checkPadTime(n): string {
		if (isNaN(n)) {
			return '00';
		}
		if (n > 59) {
			return '59';
		}
		return (n < 10 ? '0' : '') + n;
	}

	convert24to12(hours, minutes?): string {
		if (this.timeFormat === 'T_24') {
			let h1, m1, times;
			const _arrTmp = hours.split(':');
			h1 = _arrTmp[0];
			m1 = _arrTmp[1];
			m1 = this.checkPadTime(+m1);
			h1 = +h1;
			times = `${h1}:${m1}`;
			return times;
		}

		if (
			typeof hours === 'string' &&
			(hours.toUpperCase().includes('AM') || hours.toUpperCase().includes('PM'))
		) {
			return hours;
		}

		let time, h, m;

		switch (arguments.length) {
			case 0:
				console.log('incorrect data');
				return '12:00 AM';
			case 1:
				const _arrTmp = hours.split(':');
				h = _arrTmp[0];
				m = _arrTmp[1];
				break;
			default:
				h = hours;
				m = minutes;
		}

		h = isNaN(h) ? '12' : +h;
		m = this.checkPadTime(+m);
		time = h >= 12 ? `${h - 12}:${m} PM` : `${h}:${m} AM`;

		if (time.slice(0, 2) === '0:') {
			time = `12${time.slice(1)}`;
		}

		return time;
	}

	convert12to24(time): string | boolean {
		if (!time) {
			return false;
		}

		if (this.timeFormat === 'T_24') {
			let h1, m1, times;
			const _arrTmp = time
				.split(':')
				.join(' ')
				.split(' ');
			h1 = _arrTmp[0];
			m1 = _arrTmp[1];
			m1 = this.checkPadTime(+m1);
			h1 = this.checkPadTime(+h1);
			times = `${h1}:${m1}`;
			return times;
		}

		time = time.toLowerCase().replace(/\s/g, '');

		const hours = parseInt(time.substr(0, 2));
		if (time.indexOf('am') !== -1) {
			if (hours === 12) {
				time = time.replace('12', '00');
			}
			if (hours < 10) {
				time = `0${time}`;
			}
		}
		if (time.indexOf('pm') !== -1 && hours < 12) {
			time = time.replace(hours, hours + 12);
		}
		time = `${time.replace(/(am|pm)/, '')}:00`;
		return time;
	}

	getTimeStringIn24(date: Date): string {
		const hours = `0${date.getHours()}`.slice(-2);
		const minutes = `0${date.getMinutes()}`.slice(-2);
		return `${hours}:${minutes}:00`;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/helpers/time-converter.ts